import BaseApi from './base'

class Rider extends BaseApi {
  getRiderList = (query) => this.client.get(`admin/riders?${query}`)

  getRiderPortalRole = (id) => this.client.get(`admin/riders/portal-role/${id}`)

  getRiderDetail = (id) => this.client.get(`admin/riders/${id}`)
}

export default new Rider()
